import React, { useState, useRef, useEffect } from 'react';
import './App.css';
import AppointmentForm from './components/AppointmentForm';
import Header from './components/Header';
import Hero from './components/Hero';
import Locations from './components/Locations';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';
import EncryptionKeyGate from './components/EncryptionKeyGate';

function App() {
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);
  const [validatedEncryptionKey, setValidatedEncryptionKey] = useState(null);
  const modalRef = useRef(null);

  const FORM_SESSION_KEY = 'namhs_form_session';

  const closeAndResetForm = () => {
    sessionStorage.removeItem(FORM_SESSION_KEY);
    setShowAppointmentForm(false);
  };

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      if (window.confirm('Are you sure you want to close the appointment form? Any unsaved changes will be lost.')) {
        closeAndResetForm();
      }
    }
  };

  useEffect(() => {
    if (showAppointmentForm) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showAppointmentForm]);

  return (
    <EncryptionKeyGate onKeyValidated={(key) => setValidatedEncryptionKey(key)}>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <main>
          <Hero onOpenForm={() => setShowAppointmentForm(true)} />
          <Locations />
          <ContactInfo />
        </main>
        <Footer />
        
        {/* Floating Appointment Button - Currently hidden for B2B portal
            This button and its logic will be reused and reconfigured for the B2C (Business to Consumer) webpage
            where it will serve as a persistent call-to-action for direct patient appointments */}
        <button
          onClick={() => setShowAppointmentForm(true)}
          className="fixed bottom-6 right-6 bg-primary-600 hover:bg-primary-700 text-white font-semibold py-2 px-6 rounded-full shadow-lg transition-all duration-300 z-10 hidden"
          aria-hidden="true"
        >
          Book an Appointment
        </button>

        {/* Appointment Form Modal */}
        {showAppointmentForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 overflow-y-auto z-50">
            <div 
              ref={modalRef}
              className="bg-white rounded-lg max-w-5xl w-full my-8 max-h-[90vh] flex flex-col"
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200 flex-shrink-0">
                <h2 className="text-2xl font-bold text-gray-800">Schedule an Appointment</h2>
                <button
                  onClick={() => {
                    if (window.confirm('Are you sure you want to close the appointment form? Any unsaved changes will be lost.')) {
                      closeAndResetForm();
                    }
                  }}
                  className="text-gray-500 hover:text-gray-700 text-2xl"
                >
                  ✕
                </button>
              </div>
              <div className="flex-1 overflow-y-auto p-6">
                <AppointmentForm 
                  onClose={closeAndResetForm} 
                  encryptionKey={validatedEncryptionKey}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </EncryptionKeyGate>
  );
}

export default App; 